/**
 * ============================================================
 * GPS Module
 * ============================================================
 */

import CONFIG from "../config/config.js";

import AppState from "../core/app.js";

import Map from "./map.js";

import Track from "./track.js";

class GPS {

    constructor() {
        this.lastSentTime = 0;
        this.lastSentPosition = null;

        this.locationInterval = 600000;
        this.minimumDistance = 100;
    }

    init() {
        this.start();
    }

    start() {
        alert("GPS Start");

        if (!navigator.geolocation) {
            alert("Geolocation tidak tersedia");

            return;
        }

        alert("Request watchPosition");

        AppState.watchId = navigator.geolocation.watchPosition(
            this.success.bind(this),

            this.error.bind(this),

            {
                enableHighAccuracy: true,
                timeout: 30000,
                maximumAge: 0,
            },
        );
    }

    success(position) {
        AppState.currentPosition = {
            latitude: position.coords.latitude,

            longitude: position.coords.longitude,

            accuracy: position.coords.accuracy,

            altitude: position.coords.altitude,

            heading: position.coords.heading,

            speed: position.coords.speed,

            timestamp: position.timestamp,
        };

        Map.updatePosition(AppState.currentPosition);
        Track.addPoint(AppState.currentPosition);
        // =========================================
        // SEND TO SERVER
        // =========================================

        this.sendLocationToServer(
            AppState.currentPosition
        );
    }

    async sendLocationToServer(position) {

        const now = Date.now();

        const latitude = position.latitude;
        const longitude = position.longitude;

        // =========================================
        // CHECK INTERVAL
        // =========================================

        const timeElapsed =
            now - this.lastSentTime;

        // =========================================
        // CHECK DISTANCE
        // =========================================

        let distanceMoved = Infinity;

        if (this.lastSentPosition) {

            distanceMoved =
                this.calculateDistance(
                    this.lastSentPosition.latitude,
                    this.lastSentPosition.longitude,
                    latitude,
                    longitude
                );
        }

        // =========================================
        // SKIP IF TOO SOON AND NOT MOVED
        // =========================================

        if (
            this.lastSentTime > 0 &&
            timeElapsed < this.locationInterval &&
            distanceMoved < this.minimumDistance
        ) {
            return;
        }

        // =========================================
        // GET TOKEN
        // =========================================

        const token =
            localStorage.getItem("authToken");

        if (!token) {
            console.warn(
                "[GPS] Auth token tidak ditemukan"
            );

            return;
        }

        // =========================================
        // SEND LOCATION
        // =========================================

        try {

            const response =
                await fetch("/api/location", {
                    method: "POST",

                    headers: {
                        "Content-Type":
                            "application/json",

                        "Authorization":
                            `Bearer ${token}`
                    },

                    body: JSON.stringify({
                        latitude:
                            position.latitude,

                        longitude:
                            position.longitude,

                        accuracy:
                            position.accuracy,

                        altitude:
                            position.altitude,

                        speed:
                            position.speed,

                        heading:
                            position.heading
                    })
                });

            const data =
                await response.json();

            if (!response.ok) {

                console.error(
                    "[GPS] Location API error:",
                    data
                );

                return;
            }

            if (data.success) {

                console.log(
                    "[GPS] Location saved:",
                    latitude,
                    longitude
                );

                this.lastSentTime = now;

                this.lastSentPosition = {
                    latitude,
                    longitude
                };
            }

        } catch (error) {

            console.error(
                "[GPS] Failed to send location:",
                error
            );
        }
    }

    calculateDistance(
        lat1,
        lon1,
        lat2,
        lon2
    ) {

        const R = 6371000;

        const toRad =
            value =>
                value * Math.PI / 180;

        const dLat =
            toRad(lat2 - lat1);

        const dLon =
            toRad(lon2 - lon1);

        const a =
            Math.sin(dLat / 2) *
            Math.sin(dLat / 2) +

            Math.cos(toRad(lat1)) *
            Math.cos(toRad(lat2)) *

            Math.sin(dLon / 2) *
            Math.sin(dLon / 2);

        const c =
            2 *
            Math.atan2(
                Math.sqrt(a),
                Math.sqrt(1 - a)
            );

        return R * c;
    }

    error(err) {
        console.error(err.message);
    }
}

export default new GPS();
